import { combineReducers } from "redux-immutable"
import { createStore } from "redux"

// Reducers
import searchReducer from "./search"
import globalReducer from "./global"
import homeReducer from "./home"
import storyReducer from "./stories"

export const store = createStore(searchReducer)

export default function createReducer(injectedReducers) {
    return combineReducers({
        searchReducer: searchReducer,
        globalReducer: globalReducer,
        homeReducer: homeReducer,
        storyReducer: storyReducer,
        ...injectedReducers,
    })
}



// WEBPACK FOOTER //
// ./src/reducers/index.js